import React, { useState, useEffect } from 'react';
import { Layout } from '../../components/layout/Layout';
import { PageHeader } from '../../components/layout/PageHeader';
import { Card, CardContent } from '../../components/ui/Card';
import { Input } from '../../components/ui/Input';
import { Select } from '../../components/ui/Select';
import { Table, TableHeader, TableRow, TableHead, TableBody, TableCell } from '../../components/ui/Table';
import { Badge } from '../../components/ui/Badge';
import { Spinner } from '../../components/ui/Spinner';
import { getAuditLogs } from '../../modules/platform/api/devteam';
import { AuditLog } from '../../modules/platform/types';
import { showErrorToast } from '../../utils/errorHandler';
import { formatDateTime } from '../../utils/format';

export const AuditLogs: React.FC = () => {
  const [logs, setLogs] = useState<AuditLog[]>([]);
  const [loading, setLoading] = useState(true);
  const [eventType, setEventType] = useState<string>('');
  const [limit, setLimit] = useState(50);

  useEffect(() => {
    loadLogs();
  }, [eventType, limit]);

  const loadLogs = async () => {
    setLoading(true);
    try {
      const data = await getAuditLogs({
        event_type: eventType || undefined,
        limit,
      });
      setLogs(data);
    } catch (error) {
      showErrorToast(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <PageHeader
        title="Audit Logs"
        subtitle="View system audit logs and events"
      />

      <Card>
        <CardContent padding="md">
          <div className="mb-4 flex gap-4">
            <Input
              placeholder="Filter by event type..."
              value={eventType}
              onChange={(e) => setEventType(e.target.value)}
              className="flex-1"
            />
            <Select
              options={[
                { value: '50', label: '50 per page' },
                { value: '100', label: '100 per page' },
                { value: '200', label: '200 per page' },
              ]}
              value={limit.toString()}
              onChange={(e) => setLimit(Number(e.target.value))}
              className="w-40"
            />
          </div>

          {loading ? (
            <div className="flex justify-center py-8">
              <Spinner size="lg" />
            </div>
          ) : logs.length === 0 ? (
            <div className="text-center py-8 text-gray-500">
              No audit logs found.
            </div>
          ) : (
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Event Type</TableHead>
                  <TableHead>Success</TableHead>
                  {/* <TableHead>Target</TableHead> */}
                  <TableHead>Timestamp</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {logs.map((log, index) => (
                  <TableRow key={index}>
                    <TableCell>
                      <Badge variant="primary">{log.event_type}</Badge>
                    </TableCell>
                    <TableCell>{log.metadata?.success ? 'True' : 'False'}</TableCell>
                    {/* <TableCell>
                      {log.target ? (
                        <pre className="text-xs bg-gray-100 dark:bg-gray-800 p-2 rounded">
                          {JSON.stringify(log.target, null, 2)}
                        </pre>
                      ) : (
                        '-'
                      )}
                    </TableCell> */}
                    <TableCell>{formatDateTime(log.created_at)}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </CardContent>
      </Card>
    </Layout>
  );
};

